import appsLinks from './appsLinks';
export * from './appsLinks';
export default appsLinks;
